import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { Loader2, Shield } from 'lucide-react';

const AdminProtectedRoute = () => {
  const { user, loading, isAuthenticated } = useAdminAuth();
  const location = useLocation();

  // Show loading while checking admin authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-teal-500 animate-spin mx-auto mb-4" />
          <p className="text-slate-300">Verifying admin credentials...</p>
        </div>
      </div>
    );
  }

  // Redirect to admin login if not authenticated
  if (!isAuthenticated) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?redirect=${redirectTo}`} replace />;
  }

  // User is authenticated as admin, allow access
  return <Outlet />;
};

export default AdminProtectedRoute;